export default [
  {
    route: 'driver-delivery-dashboard',
    title: 'driver-delivery-dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    resource: 'Driver-delivery-dashboard',
    action: 'read',
  },
]
